/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\OfferTableUser\OfferTableUser.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Wednesday October 9th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday October 9th 2024 3:43:03 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { OfferUserType } from "Type/offer.type";
import { OfferRowUser } from "../OfferRowUserSingle/OfferRowUser";
import { useEffect, useMemo, useState } from "react";
import { TablePaper } from "Content/Table/TablePaper";
import OfferService from "Services/Offer/OfferService";

type OfferTableProps = {
    showUser?: boolean,
    Status?: string,
    carID?: string,
    companyID?: string,
    userID?: string
};

export default function OfferTable(props: OfferTableProps) {
    const [offers, setOffers] = useState<OfferUserType[]>([]);

    useEffect(() => {
        const data = {
            status: props.Status,
            carID: props.carID,
            companyID: props.companyID,
            userID: props.userID
        };
        OfferService.getAllOffers(data).then((result) => {
            setOffers(result);
        }).catch((error) => {
            console.log(error);
        });
    }, []);

    const offerKeysOffer = ["User", "Date", "Update", "Vehicle", "Quantity", "RentalCost", "Mileage", "Month", "File", "Status", "Comments", "Action"];

    const buildRows = (offers: OfferUserType[]) => {
        const offerToDisplay = [];
        for (let i = 0; i < offers.length; ++i)
            offerToDisplay.push(<OfferRowUser key={Math.random()} Offer={offers[i]} showUser={props.showUser} />);
        return offerToDisplay;
    };

    const offerValues = useMemo(() => {
        return buildRows(offers);
    }, [offers]);

    return (
        <TablePaper items={offerValues} headerList={offerKeysOffer} isCollapsable />
    );
};
